<template>
  <div>
    <div id="header-container" class="pl-5">
      <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header" />
      <div class="pt-4 text-white">
        <h3 class="text-white">{{ $t("Recipient") }}</h3>
        <span class="fz-16 fw-400">{{
          $t("View your recipient list here")
          }}</span>
      </div>
    </div>

    <b-container fluid class="pb-5">
      <b-row class="pt-3">
        <b-col cols="12">
          <div id="body-container">
            <div class="d-block d-md-flex align-items-center mb-2 p-2">
              <h5 class="fz-22 fw-700">{{ $t("Recipient List") }}</h5>
              <button class="btn btn-primary ml-auto" @click="addRecipient">
                + Add Recipient
              </button>
            </div>
            <RecipientList class="mb-2 pb-0" :dataList="data"></RecipientList>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
import LoaderComponent from "@/components/LoaderComponent";
import Recipient from "../../services/Recipient";
import RecipientList from "../../components/RecipientList.vue";

const STATUS = [
  { name: "Pending", color: 'pending' },
  { name: "Pending", color: 'pending' },
  { name: "Success", color: 'approved' },
  { name: "Failed", color: 'rejected' }
]

export default {
  name: "recipient",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isLoading: false,
      userNo: "",
      tabIndex: -1,
      selected: {},
      data: [],
    };
  },
  components: {
    LoaderComponent,
    RecipientList,
  },
  methods: {
    addRecipient() {
      this.$router.push({
        path: "/add-recipient",
      });
    },
    checkError(err) {
      try {
        this.isLoading = false;
        const response = err.response;
        if (response.status == 401) {
          console.log(response.data);
          if (typeof response.data.message === "string") {
            this.$notify({
              type: "warn",
              text: response.data.message,
            });
          } else {
            if (response.data.message["errorMsg"]) {
              this.$notify({
                type: "warn",
                text: response.data.message["errorMsg"],
              });
            } else {
              let ret = [];
              Object.keys(response.data.message).forEach((key) => {
                ret.push(response.data.message[key][0]);
              });

              this.$notify({
                type: "warn",
                html: ret.join("<br>"),
              });
            }
          }
        } else if (
          response.status == 401 &&
          response.data.name == "Unauthorized"
        ) {
          localStorage.removeItem("token");
          localStorage.removeItem("member");
          localStorage.removeItem("isFirstTime");
          this.$router.push({
            path: "/login",
          });
        } else {
          if (localStorage.getItem("token")) {
            var msg = response.data ? response.data.message : err.message;
            this.$notify({
              type: "warn",
              text: msg,
            });
          }
        }
      } catch (e) {
        console.log(err);
      }
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(() => {
      Recipient.recipientList().then((response) => {
        if (response.status == 200) {
          let res = response.data.data.data;
          self.data = res.map(item => {
            return {
              ...item,
              status: {
                name: STATUS[item.status].name,
                color: STATUS[item.status].color
              }
            };
          });
        }
      }).catch((err) => {
        self.checkError(err);
      });
    });
  },
};
</script>

<style>
.block-list-history {
  background-color: #f8f9fa;
  padding: 20px 15px !important;
  border-radius: 8px;
}
</style>
